import { Provider, EnvironmentProviders } from '@angular/core';
import { provideNativeDateAdapter, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomDateAdapter } from './date/custom-date-adapter';

export const ES_CO_DATE_FORMATS = {
  parse: { dateInput: 'DD/MM/YYYY' },
  display: {
    dateInput: 'dd/MM/yyyy',
    monthYearLabel: 'MMMM yyyy',
    dateA11yLabel: 'dd/MM/yyyy',
    monthYearA11yLabel: 'MMMM yyyy',
  }
} as const;

export const DATE_PROVIDERS: (Provider | EnvironmentProviders)[] = [
  provideNativeDateAdapter(ES_CO_DATE_FORMATS),
  { provide: MAT_DATE_LOCALE, useValue: 'es-CO' },
  { provide: DateAdapter, useClass: CustomDateAdapter },
];
